"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFragment = exports.updateQuery = void 0;
const immer_1 = require("immer");
const client_1 = require("@apollo/client");
const common_1 = require("@saffron/common");
exports.updateQuery = (store, query, fn, variables) => {
    let data;
    try {
        data = store.readQuery({
            query,
            variables,
        });
    }
    catch (_a) { }
    if (data) {
        store.writeQuery({
            query,
            variables,
            data: immer_1.produce(data, fn),
        });
    }
};
exports.updateFragment = (store, id, fields, fn) => {
    const type = id.split(":")[0];
    let data;
    try {
        data = store.readFragment({
            id,
            fragment: client_1.gql `
      fragment ${common_1.genId()} on ${type} {
        id
        ${fields}
      }
    `,
        });
    }
    catch (_a) { }
    if (data) {
        store.writeFragment({
            id,
            fragment: client_1.gql `
        fragment MoveRecipeSectionUpdateWrite on Recipe {
          cookbookSectionLookup {
            cookbook {
              id
              name
              accessLevel
            }
            section {
              id
              name
            }
          }
        }
      `,
            data: immer_1.produce(data, fn),
        });
    }
};
//# sourceMappingURL=updateQuery.js.map